import * as echarts from 'echarts'
import 'echarts/extension/dataTool'

export default {
  prepareBoxplotData: data => echarts.dataTool.prepareBoxplotData(data)
}



// WEBPACK FOOTER //
// ./src/components/Charts/chartsUtils.js